import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getSessionStorage, setSessionStorage, removeSessionStorage } from '../utils/localstorage';

// sessionStorage (not localStorage) - survives a refresh but clears when the
// tab closes, since signupDetails carries the plaintext password the user typed.
const SIGNUP_DETAILS_KEY = 'signup_details';

const defaultSignupDetails = {
    firstname: '',
    lastname: '',
    email: '',
};

const getStoredSignupDetails = () => {
    const stored = getSessionStorage(SIGNUP_DETAILS_KEY);
    if (!stored) {
        return defaultSignupDetails;
    }
    try {
        // Merge over the defaults - JSON.stringify drops any key whose value was
        // undefined, so a stored blob is not guaranteed to still have every
        // baseline field (e.g. email) that pages read without a fallback.
        return { ...defaultSignupDetails, ...JSON.parse(stored) };
    } catch {
        return defaultSignupDetails;
    }
};

export const signupnewSlice = createSlice({
    name: 'signupnew',
    initialState: {
        signupDetails: getStoredSignupDetails(),
    },
    reducers: {
        setSignup: (state: any, action: PayloadAction<object>) => {
            state.signupDetails = action.payload;
            if (Object.keys(action.payload).length === 0) {
                // Reset convention used at the end of a completed signup - wipe
                // the persisted copy too so nothing lingers after completion.
                removeSessionStorage(SIGNUP_DETAILS_KEY);
            } else {
                setSessionStorage(SIGNUP_DETAILS_KEY, JSON.stringify(action.payload));
            }
        }
    }
});

export const { setSignup } = signupnewSlice.actions;

export default signupnewSlice.reducer;
